export default __webpack_public_path__ + "static/media/interleave.7b7c0f37.jpg";